document.addEventListener('DOMContentLoaded', function() {

  /*
   * MEDICION DE FORMULARIOS SHOPIFY CON query string Y hash
   */

    var url = new URL(window.location.href);
    var postedType = ["customer_posted", "contact_posted"].find(function(key) {
      return url.searchParams.get(key) === "true";
    });
    
    if (postedType) {
      var hash = url.hash.replace("#", "");
      var gaEvent = null;
      var fbContent = null;

      // Newsletter (Cambiado de 'else if' a 'if')
      if (postedType === "customer_posted") {
        gaEvent = "adw_form_newsletter";
        fbContent = "Newsletter";
      }
      // Contact (se divide segun la pagina donde se envio el formulario)
      else if (postedType === "contact_posted") {
        var path = url.pathname.toLowerCase();

        if (path.indexOf("/pages/showrooms") !== -1) {
          gaEvent = "adw_form_showroom";
          fbContent = "Showroom";
        }
        else if (path.indexOf("/pages/arquitectos-e-interioristas") !== -1) {
          gaEvent = "adw_form_arquitectos";
          fbContent = "Arquitectos e interioristas";
        }
        else {
          gaEvent = "adw_form_contact";
          fbContent = "Contacto";
        }
      }
      
      if (typeof gtag === "function" && gaEvent) {
        gtag("event", gaEvent);
      }
      if (typeof fbq === "function" && fbContent) {
        fbq("track", "Lead", {
          content_name: fbContent
        });
      }
      
      console.log({
        postedType: postedType,
        hash: hash,
        gaEvent: gaEvent,
        fbContent: fbContent
      });
    } 

/*
   * OBSERVADOR PARA BOTÓN DINÁMICO DE WHATSAPP (DONDY)
   */
  var observer = new MutationObserver(function(mutationsList, observer) {
    for (var i = 0; i < mutationsList.length; i++) {
      var mutation = mutationsList[i];
      
      if (mutation.type === "childList") {
        // Buscamos el botón por su ID, según el HTML que compartiste
        var whatsappLink = document.querySelector("#lagoona-wa-embed");
        
        if (whatsappLink) {
          console.log('Botón de WhatsApp detectado en el DOM');
          
          whatsappLink.addEventListener("click", function() {
            console.log("Clic en WhatsApp detectado");
            if (typeof gtag === "function") {
              gtag("event", "adw_click_whatsapp");
            }
            if (typeof fbq === "function") {
              fbq("track", "Contact", { content_name: "whatsapp" });
            }
          });
          
          observer.disconnect();
          break;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('a[href^="tel"]').forEach(function(element) {
    element.classList.add("link-phone");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_phone");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "telefono" });
      }
    });
  });

  document.querySelectorAll('a[href^="mailto"]').forEach(function(element) {
    element.classList.add("link-email");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_email");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "email" });
      }
    });
  });

  document.querySelectorAll('a[href*="wa.me"]').forEach(function(element) {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });

  document.querySelectorAll('a[href*="web.whatsapp"]').forEach(function(element) {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });

  document.querySelectorAll('a[href*="m.me"]').forEach(function(element) {
    element.classList.add("link-messenger");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_messenger");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "messenger" });
      }
    });
  });
  
  document.querySelectorAll('a[href*="maps.google"]').forEach(function(element) {
    element.classList.add("link-map");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_map");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "maps" });
      }
    });
  });
});